import { Dispatch, SetStateAction } from "react";
import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import Flex from "../../../../../components/Flex";
import CustomTabs from "../../../../../components/app/CustomTabs";
import Text from "../../../../../components/Text";
import {
  ASSESSMENT_MAIN_TABS,
  SUBMITTED_SUB_TABS,
  SEND_SCHEDULED_SUB_TABS,
} from "./AssessmentConstant";
import { AssessmentFilterData } from "./AssessmentsList";
import { AssessmentEndActions } from "./AssessmentEndActions";
import { GridRowSelectionModel } from "@mui/x-data-grid";

interface AssessmentTopBarProps {
  activeAssessment: string;
  setActiveAssessment: (v: string) => void;
  setSearchParams: (v: {
    activeAssessment?: string;
    activeSubTab?: string;
  }) => void;
  setFilters: Dispatch<SetStateAction<AssessmentFilterData>>;
  filters: AssessmentFilterData;
  setSearchStringKey?: (v: string) => void;
  searchStringKey?: string;
  isSendScheduleAssessment: boolean;
  rowSelectionModel?: GridRowSelectionModel;
  assessments?: any[];
  onExportAssessment?: (selected: "csv" | "pdf") => void;
  activeSubTab?: string;
  setActiveSubTab?: (v: string) => void;
  setRowSelectionModel?: (v: GridRowSelectionModel) => void;
  setArchive?: (v: boolean) => void;
  archive?: boolean;
}
const AssessmentTopBar = ({
  setRowSelectionModel,
  activeAssessment,
  setActiveAssessment,
  setSearchParams,
  setFilters,
  filters,
  setSearchStringKey,
  searchStringKey,
  rowSelectionModel = [],
  assessments = [],
  onExportAssessment,
  activeSubTab,
  setActiveSubTab,
  setArchive,
  archive,
}: AssessmentTopBarProps) => {
  const isSubmittedTab = activeAssessment === "submitted";
  const subTabs = isSubmittedTab ? SUBMITTED_SUB_TABS : SEND_SCHEDULED_SUB_TABS;
  // Ensure we have a valid sub-tab value
  const defaultSubTab = subTabs[0].value;
  const currentSubTab =
    activeSubTab && subTabs.some((tab) => tab.value === activeSubTab)
      ? activeSubTab
      : defaultSubTab;

  return (
    <Flex flexDirection={"column"} gap={0} width={"100%"}>
      <Flex
        justifyContent={"space-between"}
        height={"2.5rem"}
        alignItems={"center"}
      >
        <Box sx={{ minWidth: "fit-content", flexShrink: 0 }}>
          <CustomTabs
            tabsData={ASSESSMENT_MAIN_TABS}
            value={activeAssessment}
            onChange={(v) => {
              setActiveAssessment(v);
              setFilters({});
              setRowSelectionModel?.([]);
              setArchive?.(false);
              // Reset to first sub-tab when main tab changes
              const newSubTabs =
                v === "submitted"
                  ? SUBMITTED_SUB_TABS
                  : SEND_SCHEDULED_SUB_TABS;
              const firstSubTab = newSubTabs[0].value;
              setActiveSubTab?.(firstSubTab);
              setSearchParams({
                activeAssessment: v,
                activeSubTab: firstSubTab,
              });

              // Clear search string on tab change but preserve filters
              setSearchStringKey?.("");
            }}
          />
        </Box>
        <AssessmentEndActions
          activeSubTab={activeSubTab}
          activeAssessment={activeAssessment}
          setFilters={setFilters}
          filters={filters}
          setSearchStringKey={setSearchStringKey}
          searchStringKey={searchStringKey}
          rowSelectionModel={rowSelectionModel}
          assessments={assessments}
          onExportAssessment={onExportAssessment}
          setArchive={setArchive}
          archive={archive}
        />
      </Flex>
      <Box>
        <RadioGroup
          key={`radio-group-${activeAssessment}`}
          row
          name={`assessment-sub-tabs-${activeAssessment}`}
          value={currentSubTab}
          onChange={(e) => {
            const newValue = e.target.value;
            if (setActiveSubTab) {
              setActiveSubTab(newValue);
            }
            setSearchParams({ activeAssessment, activeSubTab: newValue });
            setSearchStringKey?.("");
            setRowSelectionModel?.([]);
          }}
        >
          {subTabs.map((tab) => (
            <FormControlLabel
              key={tab.value}
              value={tab.value}
              control={<Radio size="small" color="primary" />}
              label={
                <Flex
                  gap={0.5}
                  alignItems={"center"}
                  sx={{ cursor: "pointer" }}
                >
                  <Text fontSize={"14px"}>{tab.label}</Text>
                </Flex>
              }
              sx={{ cursor: "pointer" }}
            />
          ))}
        </RadioGroup>
      </Box>
    </Flex>
  );
};

export default AssessmentTopBar;
